import { isNotNil } from "client/Misc/utils";
import { TileRenderState } from "../common";
import { InteractionState } from "../../Tiles/TileContext";

export function isHiddenByConditionalAccess(
	tile: Pick<TileRenderState, "data" | "interactionState">
): boolean {
	const {
		data,
		interactionState
	} = tile;

	return isNotNil(data.conditionalAccess)
		&& data.conditionalAccess.hideTile
		&& interactionState !== InteractionState.Selectable;
}